export default __webpack_public_path__ + "static/media/vantrust_logo.93022909.svg";